import { type PlanViewerAction, type PlanViewerState } from "./types"

export function createInitialState(defaultPlanIndex: number): PlanViewerState {
  return { zoom: 100, pan: { x: 0, y: 0 }, selectedPlanIndex: defaultPlanIndex }
}

export function planViewerReducer(state: PlanViewerState, action: PlanViewerAction): PlanViewerState {
  switch (action.type) {
    case "ZOOM_AND_PAN":
      return { ...state, zoom: action.zoom, pan: action.pan }
    case "SET_ZOOM":
      return { ...state, zoom: action.zoom }
    case "SET_PAN":
      return { ...state, pan: action.pan }
    case "SET_SELECTED_PLAN_INDEX":
      return { ...state, selectedPlanIndex: action.index }
    case "RESET":
      return { ...state, zoom: action.zoom, pan: action.pan }
  }
}
